import React, { FC, memo, useMemo } from "react";
import { LayoutChangeEvent } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button, Text } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Footer } from "../Footer";
import { style as basketFooterStyle } from "./BasketFooter.styles";

interface FooterProps {
  readonly onPress: () => void;
  readonly onLayout?: (event: LayoutChangeEvent) => void;
}

const BasketFooter: FC<FooterProps> = ({ onPress, onLayout }) => {
  const basketInfoFreeShippingAndReturnText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.BASKET_INFO_FREE_SHIPPING_AND_RETURN,
  });
  const basketCtaText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.BASKET_CTA,
  });

  const style = useMemo(() => basketFooterStyle(), []);

  return (
    <Footer onLayout={onLayout}>
      <Text level={3} style={style.text} variant="detail">
        {basketInfoFreeShippingAndReturnText}
      </Text>

      <Button size="small" style={{ button: style.button }} testID="start-checkout-button" onPress={onPress}>
        {basketCtaText}
      </Button>
    </Footer>
  );
};

const MemoizedBasketFooter = memo(BasketFooter);

export { MemoizedBasketFooter as BasketFooter };
